<script>
// import store from '../store'
import configurator from './configurator'

export default {
  name: 'modelPickerItem',
  props: {
    scene: Object
  },
  computed: {
    banner () {
      const imagePath = require.context('../assets/', true)
      // eslint-disable-next-line
      return API_URL + imagePath(this.scene.banner, true)
    },
    isActive () {
      return this.$store.getters['scenes/getCurrentScene'].sceneuid === this.scene.sceneuid
    },
    ctaText () {
      // checks if this model is the currently active one
      const isActive = this.$store.getters['scenes/getCurrentScene'].sceneuid === this.scene.sceneuid
      if (isActive) { return 'Reload model' } else { return 'Select model' }
    }
  },
  methods: {
    selectModel () {
      configurator.methods.loadScene(this.scene.sceneuid)
      this.$store.commit('model/setProperty', {property: 'modelPicker', value: false})
    }
  }
}
</script>

<template>
<md-card md-with-hover>
  <md-ripple>
    <md-card-media v-if="scene.banner">
      <img @click="selectModel" :src="this.banner" alt="Banner">
    </md-card-media>

    <md-card-header>
      <div class="md-title">{{scene.scenetitle}}</div>
      <div v-if="isActive" class="md-subhead">This is the current model</div>
    </md-card-header>

    <md-card-content>
      {{scene.header}}
    </md-card-content>

    <md-card-actions>
      <md-button class="md-accent" @click="selectModel">{{this.ctaText}}</md-button>
    </md-card-actions>
  </md-ripple>
</md-card>
</template>

<style lang="scss" scoped>
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;

    @media screen and (max-width: 768px) {
      width: 47%;
    }
    @media screen and (max-width: 500px) {
      width: 100%;
    }
  }
</style>
